import * as types from "./mutations-type";
export default{
   
    [types.SET_BOLETIM](state,payload){
        state.boletim = payload
    },
    
}